import { useContext } from "react";

import { LocContext } from "@app/shared/lib/localization";

export const useLoc = () => useContext(LocContext);
